import {
  addTeamReferencesAndIdsToCombatants,
} from "./team-utilities.js"

import {addSaltedItemInstanceIdsToCombatants} from './addSaltedItemInstanceIdsToCombatants'

export function getInitialBattleState(combatants = {}, teams = {}) {

  const combatantsWithTeams = addTeamReferencesAndIdsToCombatants(combatants, teams); //??? don't seem to need this anymore?
  const combatantsWithSaltedItems = addSaltedItemInstanceIdsToCombatants(combatantsWithTeams);


  return {
    isBattleInit: true,
    teams: teams,
    combatants: combatantsWithSaltedItems,

    //Get all initial values
    combatantSelectingAction: "",
    rolloutId: "initial",
    cloudQueue: [],

    hpRatingsOfTeamsPerTurnSeries: [],
    turnReporting: {},

    rolloutHistory: [],
    rolloutData: [],
  }
}




// WEBPACK FOOTER //
// ./src/battle/lifecycle/init-battle.js